import { HttpClient } from '@remodeling/base';
import {
  CreateSeqConsultRequest,
  CreateSeqConsultResponse,
} from '../../model/dto';

export class CreateSeqConsultGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateSeqConsultRequest) {
    return await this.httpClient.request<CreateSeqConsultResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/base`,
      body: req,
    });
  }
}
